import type { ContactFormValues } from '../types'
import type { FormikProps } from 'formik'

import { Box } from '@mui/material'
import Avatar from '@rentspree/component-2023.components.atoms.avatar'
import TextInput from '@rentspree/component-2023.components.atoms.text-input'
import Typography from '@rentspree/component-2023.components.atoms.typography'

import styles from '../index.module.scss'

export interface ContactFormProps {
  formik: FormikProps<ContactFormValues>
  contactDetails: ContactDetails
}

export const ContactForm: React.FC<ContactFormProps> = ({ formik, contactDetails }) => {
  const { values, handleChange, handleBlur, touched, errors } = formik

  return (
    <Box data-testid="contact-form" mb={2} className={styles.contactFormContainer}>
      <Box className={styles.contactDetailsContainer}>
        <Avatar className={styles.avatar} color="gray" size="large" src={contactDetails.imageSrc} />
        <Box className={styles.contactDetailsTextContainer}>
          <Typography variant="body-large">{contactDetails.displayName}</Typography>
          <Typography variant="caption">
            {contactDetails.brokerageName || contactDetails.businessName
              ? [contactDetails.brokerageName, contactDetails.businessName]
                  .filter((value) => !!value)
                  .join(' | ')
              : '-'}
          </Typography>
        </Box>
      </Box>
      <Box className={styles.messageInputContainer}>
        <Typography variant="title">Message</Typography>
        <TextInput
          label="Add a message (optional)"
          name="message"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.message}
          error={!!touched?.message && !!errors?.message}
          minRows={4}
          multiline
          validTextCount={1000}
          helperText=" "
          inputProps={{ maxLength: 1000 }}
        />
      </Box>
    </Box>
  )
}
